import { MathNormBoxIcon } from './MathNormBoxIcon';

/**
 * author: Michael Irigoyen
 * id 4FBD0287-AD44-452B-A97A-E5FDD3542A1F
 * name math-norm-box
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/math-norm-box.svg
 * tags
 * - Math 
 * - Developer / Languages 
 */
export const ParallelBoxIcon = MathNormBoxIcon;
export default ParallelBoxIcon